/**
 * 360° spin + video cho PDP KNT.
 *
 * Lấy dữ liệu từ CRM Celoria (giống musecarat), qua:
 *   GET {apiBase}/api/v1/media/{websiteId}/{handle}?type=spin|video&material=...&carat=...
 *     - type=spin  -> { error:false, data:{ base_url, frame_count } }   (frame = {base_url}/{i}.jpg)
 *     - type=video -> { error:false, data:{ items:[ { url, mime_type, poster_url, carat } ] } }
 *
 * Khác musecarat (gallery dạng tab): KNT dùng MỘT gallery Flickity. Script này CHỈ port phần
 * fetch + engine xoay frame + video, còn lớp chèn thì cắm thêm cell vào cuối Flickity hiện có
 * (sau tất cả ảnh -> 360 rồi Video) kèm thumbnail trong dải bên trái, và refetch khi đổi
 * Material/Carat. Fail-open: thiếu config / API lỗi / không có data -> không chèn gì.
 */
(function () {
  'use strict';

  if (window.__kntRingMediaReady) return;
  window.__kntRingMediaReady = true;

  var config = document.getElementById('knt-ring-spin-config');
  if (!config) return;

  var apiBase = config.getAttribute('data-api-base');
  var websiteId = config.getAttribute('data-website-id');
  var handle = config.getAttribute('data-handle');
  if (!apiBase || !websiteId || !handle) return;

  var matIndex = parseInt(config.getAttribute('data-material-index'), 10);

  // Danh sách giá trị option Material (để lọc thumbnail theo màu qua alt-text).
  var MATERIALS = [];
  try {
    var parsedMats = JSON.parse(config.getAttribute('data-materials') || '[]');
    if (Array.isArray(parsedMats)) MATERIALS = parsedMats;
  } catch (e) {}

  var PIXELS_PER_FRAME = 5;

  // Cung chỉ hướng kéo (copy verbatim từ musecarat pdp-hosted-media.js).
  var SPIN_TRACK_SVG =
    '<svg class="knt-spin-hint-track" width="151" height="18" viewBox="0 0 151 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M150.417 0.644691C148.383 2.02048 146.196 3.1495 143.962 4.15117C143.812 4.21799 143.637 4.15134 143.571 4.00225C143.504 3.85317 143.571 3.67812 143.72 3.61131C143.722 3.61026 143.726 3.6085 143.728 3.60763C145.969 2.68138 148.164 1.62813 150.21 0.329868C150.298 0.273574 150.414 0.299178 150.47 0.386867C150.525 0.472991 150.501 0.587348 150.417 0.644691V0.644691Z" fill="#999999"></path>' +
    '<path d="M137.1 6.77542L130.053 8.8256C129.813 8.89523 129.563 8.75755 129.493 8.51813C129.423 8.27871 129.561 8.02826 129.8 7.95863L129.806 7.95705L129.835 7.94916L136.866 6.04L136.892 6.03298C137.097 5.97721 137.309 6.09857 137.365 6.30414C137.42 6.50725 137.302 6.71684 137.1 6.77542Z" fill="#999999"></path>' +
    '<path d="M122.906 10.4761L115.693 11.8112C115.376 11.8697 115.072 11.6607 115.014 11.3444C114.955 11.028 115.164 10.7241 115.481 10.6655C115.483 10.665 115.485 10.6646 115.488 10.6643L115.513 10.6601L122.706 9.46141L122.727 9.45791C123.008 9.41108 123.275 9.6012 123.322 9.88289C123.368 10.1612 123.182 10.4247 122.906 10.4761L122.906 10.4761Z" fill="#999999"></path>' +
    '<path d="M108.436 12.8532L101.146 13.6473C100.794 13.6856 100.477 13.4311 100.439 13.0789C100.4 12.7265 100.655 12.4099 101.007 12.3715L101.011 12.371L101.03 12.3691L108.286 11.6221L108.305 11.6201C108.646 11.5851 108.95 11.8327 108.985 12.1733C109.02 12.5127 108.774 12.8161 108.436 12.8531L108.436 12.8532Z" fill="#999999"></path>' +
    '<path d="M49.8932 13.6545L42.6008 12.8621C42.2598 12.8249 42.0135 12.5185 42.0506 12.1776C42.0875 11.838 42.3917 11.5923 42.7311 11.627L42.7503 11.6289L50.0093 12.3742L50.0283 12.3761C50.3815 12.4122 50.6384 12.7279 50.6021 13.0812C50.5659 13.4344 50.2502 13.6912 49.897 13.6551L49.8932 13.6545V13.6545Z" fill="#999999"></path>' +
    '<path d="M35.3374 11.8231L28.1195 10.4889C27.8375 10.4368 27.6512 10.166 27.7033 9.88392C27.7548 9.60522 28.02 9.42 28.2984 9.46613L28.3199 9.46964L35.5176 10.6664L35.5397 10.67C35.8586 10.723 36.0741 11.0245 36.0211 11.3434C35.9681 11.6622 35.6665 11.8778 35.3477 11.8248C35.3452 11.8245 35.3398 11.8234 35.3373 11.8231H35.3374Z" fill="#999999"></path>' +
    '<path d="M20.9636 8.83857L13.9126 6.79015C13.7073 6.73052 13.5891 6.51566 13.6488 6.31045C13.7078 6.10751 13.9183 5.98965 14.1215 6.04472L14.1474 6.05173L21.1818 7.95844L21.2087 7.96563C21.4503 8.03105 21.5931 8.28011 21.5276 8.5218C21.4621 8.76348 21.2132 8.90626 20.9715 8.84066C20.9696 8.84012 20.9655 8.83908 20.9636 8.83856L20.9636 8.83857Z" fill="#999999"></path>' +
    '<path d="M7.04703 4.16889C4.81005 3.16793 2.6207 2.03944 0.58358 0.665061C0.496767 0.606467 0.473878 0.488776 0.532458 0.401963C0.589902 0.316716 0.705308 0.293742 0.791604 0.348111C2.84108 1.6448 5.03842 2.69682 7.28126 3.62185C7.43332 3.68411 7.50611 3.85793 7.44394 4.00999C7.38168 4.16205 7.20794 4.23484 7.05588 4.17258C7.05359 4.17171 7.0493 4.16978 7.04703 4.1689V4.16889Z" fill="#999999"></path>' +
    '<path d="M65.0514 11.1752L58.1611 13.5809L64.6288 16.9225L65.0514 11.1752Z" fill="black"></path>' +
    '<path d="M86.8892 11.2564L87.2593 17.0035L93.7795 13.5937L86.8892 11.2564Z" fill="black"></path>' +
    '<ellipse cx="75.4999" cy="14.5645" rx="1.9306" ry="1.9306" fill="black"></ellipse>' +
    '</svg>';

  var PLAY_SVG = '<svg viewBox="0 0 24 24" width="26" height="26"><path d="M8 5v14l11-7z"></path></svg>';

  // --- Trạng thái ---------------------------------------------------------

  var flkty = null;
  var nav = null;
  var reqId = 0; // token loại bỏ kết quả fetch cũ khi đổi variant nhanh
  var changeBound = false;
  var navBound = false;
  var dragDir = 1; // hướng vuốt gần nhất (1 = tiến/phải, -1 = lùi)
  var last = { material: null };

  var spin = { frames: [], current: 0, viewer: null, img: null, cell: null, thumb: null };
  var video = { items: [], cell: null, thumb: null, el: null };

  var mediaCache = {}; // material -> Promise<[spinData, videoData]> (prefetch để 360/video sẵn sàng sớm)

  // Trạng thái kéo xoay (dùng chung, gộp bằng rAF).
  var drag = { active: false, startX: 0, startFrame: 0, pending: false, latest: null, docBound: false };

  // --- API ----------------------------------------------------------------

  function materialSlug(m) {
    return String(m || '').toLowerCase().replace(/\s+/g, '-');
  }

  // Sp moissanite dùng CHUNG media 360/video với bản lab-diamond (không có media riêng). CRM lưu theo
  // handle lab. Liquid tính sẵn data-media-handle từ metafield stone_type (cặp lab/mois không luôn cùng
  // tên, vd Freyja mois <-> Penelope lab); nếu thiếu thì đoán bằng cách đổi 'moissanite' -> 'lab-diamond'.
  var mediaHandle = config.getAttribute('data-media-handle') ||
    (handle.indexOf('moissanite') !== -1 ? handle.replace('moissanite', 'lab-diamond') : handle);

  function fetchMedia(type, material) {
    // material bắt buộc + slug hoá; header Accept:application/json bắt buộc (thiếu -> server trả
    // HTML redirect). carat bỏ qua: spin không đổi theo carat, video trả mảng items (lấy items[0]).
    var url = apiBase + '/api/v1/media/' + websiteId + '/' + encodeURIComponent(mediaHandle) +
      '?type=' + type + '&material=' + encodeURIComponent(materialSlug(material));

    // cache: 'no-store' — bắt buộc, nếu không trình duyệt có thể giữ response cũ mãi mãi (đã gặp
    // thật: client đổi video mới trên server nhưng khách vẫn thấy video cũ vì browser cache response
    // GET này theo heuristic caching, không bao giờ revalidate lại).
    return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) { return json && json.error === false && json.data ? json.data : null; })
      .catch(function () { return null; });
  }

  // Lấy [spin, video] cho material, cache theo material (prefetch chạy trước cả khi Flickity sẵn sàng).
  function getMedia(material) {
    material = material || '';
    if (!mediaCache[material]) {
      mediaCache[material] = Promise.all([fetchMedia('spin', material), fetchMedia('video', material)]);
    }
    return mediaCache[material];
  }

  // Bắn request ngay khi script chạy, song song với lúc Flickity đang khởi tạo -> giảm độ trễ chèn.
  getMedia(config.getAttribute('data-init-material') || '');

  // --- Flickity helpers ---------------------------------------------------

  function ensureFlkty() {
    if (!window.Flickity) return false;
    var main = document.querySelector('#product-photos .js-carousel-main') ||
      document.querySelector('.js-carousel-main');
    if (!main) return false;
    flkty = window.Flickity.data(main);
    if (!flkty) return false;
    var scope = flkty.element.closest('#product-photos') || document;
    nav = scope.querySelector('.js-thumb-carousel-nav');
    return true;
  }

  /* Ảnh lớn dùng Flickity fade: nó giữ index slide cũ ở fadeIndex/fadeHideIndex và KHÔNG cập nhật khi
     ta remove/insert cell 360/video. Đang đứng ở ảnh cuối (vd bấm mũi tên tới cuối) rồi đổi màu -> số
     slide giảm -> fadeSlides() đọc slides[index cũ] = undefined -> throw 'setOpacity'; fadeHideIndex
     không bao giờ được gán lại nên MỌI lần đổi màu sau đều lỗi, không chèn được 360/video nữa.
     Gọi trước mỗi lần thêm/bớt cell. updateSlides() của fade tự đặt lại opacity các slide sau đó. */
  function resetFade() {
    if (!flkty) return;
    flkty.fadeIndex = 0;
    flkty.fadeHideIndex = null;
  }

  function safeRemove(el) {
    if (!el) return;
    resetFade();
    try {
      flkty.remove(el);
    } catch (e) {
      if (el.parentNode) el.parentNode.removeChild(el);
      try { flkty.reloadCells(); flkty.resize(); } catch (_) {}
    }
  }

  function isMine(t) {
    return t.classList.contains('knt-spin-thumb') || t.classList.contains('knt-video-thumb');
  }

  // Chuẩn hoá: bỏ mọi ký tự không phải chữ/số -> khớp material dù ghi dạng "14k White Gold",
  // "14k_White_Gold" (tên file) hay "14k-white-gold".
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  /* Lọc gallery so theo data-knt-mat (material đầy đủ karat+màu) đã stamp server-side — đã tính kế thừa
     block cho video/ảnh phụ. Không gộp karat nên 14k/18k không hiện ảnh trùng của nhau. norm(material)
     phải khớp cách chuẩn hoá trong snippets/product-image-gallery.liquid. data-knt-mat rỗng = generic. */

  /* Lọc thumbnail theo material: ẩn thumbnail của material KHÁC dựa trên data-knt-mat (server-side stamp,
     đã tính kế thừa block cho video/ảnh phụ). data-knt-mat rỗng = generic -> luôn hiện.
     Vá cho lỗi có sẵn của theme: ảnh KNT không dùng tag #group_ nên setThumbByColor bó tay. */
  function filterThumbs(material) {
    if (!nav || !MATERIALS.length) return;
    var cur = norm(material);
    nav.querySelectorAll('.js-thumb-item').forEach(function (t) {
      if (isMine(t)) return;
      var c = t.getAttribute('data-knt-mat') || ''; // '' = generic -> luôn hiện (fail-open)
      // Dùng class (không inline style) vì rule mobile #thumb-slider-wrapper .carousel-cell dùng
      // !important sẽ đè inline display:none.
      t.classList.toggle('knt-color-hidden', !!c && !!cur && c !== cur);
    });
  }

  /* Thumbnail ảnh thứ n đang hiện (bỏ qua thumbnail 360/video của ta và ảnh đang bị ẩn). */
  function nthVisibleImageThumb(n) {
    if (!nav) return null;
    var items = nav.querySelectorAll('.js-thumb-item');
    var count = 0, last = null;
    for (var i = 0; i < items.length; i++) {
      var t = items[i];
      if (isMine(t) || t.classList.contains('knt-color-hidden')) continue;
      last = t;
      if (++count >= n) return t;
    }
    return last; // ít hơn n ảnh -> lấy ảnh cuối cùng đang hiện (hoặc null)
  }

  /* Đặt thumbnail 360 rồi Video ngay SAU ảnh thứ 2 đang hiện (spin trước video). */
  function placeThumbs() {
    if (!nav) return;
    var after = nthVisibleImageThumb(2);
    [spin.thumb, video.thumb].forEach(function (t) {
      if (!t) return;
      if (after && after.parentNode === nav) nav.insertBefore(t, after.nextSibling);
      else nav.appendChild(t);
      after = t;
    });
  }

  /* Index Flickity của cell ảnh chính thứ n khớp material (khớp = màu hiện tại HOẶC ảnh generic
     không màu). Trả -1 nếu không có; nếu ít hơn n thì trả cell khớp cuối cùng. */
  function nthMatchingCellIndex(material, n) {
    if (!flkty) return -1;
    var cur = norm(material);
    var cells = flkty.getCellElements();
    var count = 0, lastIdx = -1;
    for (var i = 0; i < cells.length; i++) {
      var el = cells[i];
      if (el.classList.contains('knt-spin-slide') || el.classList.contains('knt-video-slide')) continue;
      var c = el.getAttribute('data-knt-mat') || '';
      if (c && cur && c !== cur) continue; // cell của màu khác -> bỏ qua
      lastIdx = i;
      if (++count >= n) return i;
    }
    return lastIdx;
  }

  /* Đồng bộ data-slide-index của MỌI cell + thumbnail theo thứ tự thật trong Flickity (vì ta chèn
     360/video vào giữa nên index các ảnh phía sau bị xê dịch). Khớp thumbnail<->cell qua data-image-id. */
  function resyncIndices() {
    if (!flkty) return;
    var cells = flkty.getCellElements();
    var idxById = {};
    cells.forEach(function (el, i) {
      el.setAttribute('data-slide-index', i);
      var id = el.getAttribute('data-image-id');
      if (id) idxById[id] = i;
    });
    if (nav) nav.querySelectorAll('.js-thumb-item').forEach(function (t) {
      var id = t.getAttribute('data-image-id');
      if (id != null && idxById[id] != null) t.setAttribute('data-slide-index', idxById[id]);
    });
  }

  /* Thumbnail trong dải trái, dùng lại class .js-thumb-item để handler change của theme
     tự tô đậm; click -> flkty.select (theme lo switchMedia + highlight). */
  function addThumb(kind, index, imgSrc) {
    if (!nav) return null;

    var imageId = kind === 'spin' ? 'knt-spin' : 'knt-video';
    var t = document.createElement('div');
    t.className = kind + '-thumbnail product-single__thumbnails-item carousel-cell js-thumb-item knt-' + kind + '-thumb';
    t.setAttribute('data-slide-index', index);
    t.setAttribute('data-image-id', imageId);
    t.setAttribute('tabindex', '0');

    var overlay = kind === 'spin' ?
      '<div class="knt-thumb-badge">360&deg;</div>' :
      '<div class="knt-thumb-play">' + PLAY_SVG + '</div>';
    t.innerHTML = '<img class="js-thumb-item-img" src="' + (imgSrc || '') + '" alt="' + imageId + '">' + overlay;

    function go() { if (flkty) flkty.select(parseInt(t.getAttribute('data-slide-index'), 10)); }
    t.addEventListener('click', go);
    t.addEventListener('keypress', function (e) { if (e.which === 13) go(); });

    // Không append ở đây — placeThumbs() sẽ đặt đúng vị trí (sau 2 ảnh đầu đang hiện).
    return t;
  }

  function makeMainCell(kind, innerHtml) {
    var imageId = kind === 'spin' ? 'knt-spin' : 'knt-video';
    var cell = document.createElement('div');
    cell.className = kind + '-slide carousel-cell js-main-carousel-cell knt-' + kind + '-slide';
    cell.setAttribute('data-image-id', imageId);
    cell.setAttribute('tabindex', '-1');
    cell.innerHTML =
      '<div class="product-gallery__media-container product-media--' + imageId + ' knt-' + kind + '"' +
      ' data-product-single-media-wrapper data-thumbnail-id="product-template-' + imageId + '"' +
      ' data-media-id="product-template-' + imageId + '">' + innerHtml + '</div>';
    return cell;
  }

  // --- 360 ----------------------------------------------------------------

  function setFrame(index) {
    if (!spin.frames.length || !spin.img) return;
    var c = spin.frames.length;
    spin.current = ((index % c) + c) % c;
    spin.img.src = spin.frames[spin.current];
  }

  function pointerX(e) {
    return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
  }

  function applyLatest() {
    if (!drag.latest) return;
    setFrame(drag.startFrame - Math.round((pointerX(drag.latest) - drag.startX) / PIXELS_PER_FRAME));
  }

  function onDragStart(e) {
    if (!spin.viewer) return;
    drag.active = true;
    drag.startX = pointerX(e);
    drag.startFrame = spin.current;
    spin.viewer.classList.add('dragging');
    // Chặn Flickity khởi động drag trượt slide khi đang xoay 360.
    e.stopPropagation();
  }

  function onDragMove(e) {
    if (!drag.active) return;
    // Chặn cuộn trang trên mobile khi đang xoay (touchmove trên viewer là non-passive).
    if (e.type === 'touchmove' && e.cancelable) e.preventDefault();
    drag.latest = e;
    if (drag.pending) return;
    drag.pending = true;
    requestAnimationFrame(function () {
      drag.pending = false;
      if (drag.active) applyLatest();
    });
  }

  function onDragEnd() {
    if (!drag.active) return;
    applyLatest(); // áp nốt lần di chuyển cuối
    drag.active = false;
    drag.latest = null;
    if (spin.viewer) spin.viewer.classList.remove('dragging');
  }

  function bindSpinDrag() {
    if (!spin.viewer) return;
    spin.viewer.addEventListener('mousedown', onDragStart);
    // Touch bind trên chính viewer với passive:false để preventDefault() chặn cuộn trang khi xoay.
    // (Touch events vẫn nhắm vào viewer suốt cú kéo dù ngón tay ra ngoài, nên không cần document.)
    spin.viewer.addEventListener('touchstart', onDragStart, { passive: false });
    spin.viewer.addEventListener('touchmove', onDragMove, { passive: false });
    spin.viewer.addEventListener('touchend', onDragEnd);
    spin.viewer.addEventListener('touchcancel', onDragEnd);
    if (!drag.docBound) {
      drag.docBound = true;
      document.addEventListener('mousemove', onDragMove);
      document.addEventListener('mouseup', onDragEnd);
    }
  }

  function applySpin(data) {
    spin.frames = [];
    for (var i = 0; i < data.frame_count; i++) {
      spin.frames.push(data.base_url + '/' + i + '.jpg');
    }
    if (!spin.frames.length) return null;

    var cell = makeMainCell('spin',
      '<div class="knt-spin-viewer"><img class="knt-spin-img" alt="360&deg;">' +
      '<div class="knt-spin-hint"><span class="knt-spin-hint-label">Drag to spin</span>' +
      SPIN_TRACK_SVG + '</div></div>');

    spin.cell = cell;
    spin.viewer = cell.querySelector('.knt-spin-viewer');
    spin.img = cell.querySelector('.knt-spin-img');
    spin.current = 0;
    spin.img.src = spin.frames[0];

    // Nạp sẵn các frame còn lại để kéo không giật.
    for (var j = 1; j < spin.frames.length; j++) { new Image().src = spin.frames[j]; }

    // index đặt sau qua resyncIndices() (cell được chèn vào giữa nên chưa biết index).
    spin.thumb = addThumb('spin', -1, spin.frames[0]);
    bindSpinDrag();
    return cell; // reload() sẽ flkty.insert() vào đúng vị trí (sau 2 ảnh của màu hiện tại)
  }

  function removeSpin() {
    if (spin.cell) safeRemove(spin.cell);
    if (spin.thumb && spin.thumb.parentNode) spin.thumb.parentNode.removeChild(spin.thumb);
    spin.cell = spin.thumb = spin.viewer = spin.img = null;
    spin.frames = [];
    spin.current = 0;
  }

  // --- Video --------------------------------------------------------------

  function applyVideos(items) {
    video.items = items;
    var first = items[0];

    var cell = makeMainCell('video',
      '<div class="knt-hosted-video"><div class="knt-hosted-video-inner">' +
      '<video class="knt-hosted-video-el" muted loop playsinline preload="none"></video>' +
      '<div class="knt-play-overlay"><div class="knt-play-button">' + PLAY_SVG + '</div></div>' +
      '</div></div>');

    video.cell = cell;
    video.el = cell.querySelector('video');
    video.el.setAttribute('src', first.url);
    if (first.poster_url) video.el.setAttribute('poster', first.poster_url);

    // index đặt sau qua resyncIndices().
    video.thumb = addThumb('video', -1, first.poster_url || '');
    bindVideo(cell);
    return cell; // reload() sẽ flkty.insert() vào đúng vị trí
  }

  function bindVideo(cell) {
    var inner = cell.querySelector('.knt-hosted-video-inner');
    var el = cell.querySelector('video');
    if (!inner || !el) return;

    inner.addEventListener('click', function () {
      if (el.paused) {
        var p = el.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        el.pause();
      }
    });
    el.addEventListener('play', function () { inner.classList.add('playing'); });
    el.addEventListener('pause', function () { inner.classList.remove('playing'); });
  }

  function removeVideo() {
    if (video.el) { try { video.el.pause(); } catch (e) {} }
    if (video.cell) safeRemove(video.cell);
    if (video.thumb && video.thumb.parentNode) video.thumb.parentNode.removeChild(video.thumb);
    video.cell = video.thumb = video.el = null;
    video.items = [];
  }

  // --- Điều phối ----------------------------------------------------------

  function bindChangeOnce() {
    if (changeBound || !flkty) return;
    changeBound = true;
    flkty.on('change', function () {
      // Trên slide 360: tắt kéo-trượt của Flickity để cú kéo dùng để XOAY nhẫn, không trượt sang
      // slide khác (giống cách theme tắt drag cho model-slide 3D). Rời đi thì bật lại.
      var onSpin = spin.cell && flkty.selectedElement === spin.cell;
      if (onSpin && flkty.options.draggable) {
        flkty.options.draggable = false;
        if (flkty.updateDraggable) flkty.updateDraggable();
      } else if (!onSpin && !flkty.options.draggable) {
        flkty.options.draggable = true;
        if (flkty.updateDraggable) flkty.updateDraggable();
      }
      // Rời khỏi slide video thì dừng phát.
      if (video.el && flkty.selectedElement !== video.cell) video.el.pause();
    });
  }

  // Cell chính có "khớp" màu hiện tại không (360/video luôn khớp; ảnh generic không màu cũng khớp).
  function cellMatches(el) {
    if (!el) return true;
    if (el === spin.cell || el === video.cell) return true;
    var c = el.getAttribute('data-knt-mat') || '';
    var cur = norm(last.material);
    return !c || !cur || c === cur;
  }

  // Index cell khớp màu kế tiếp theo hướng dir (có wrap).
  function nextMatchingCell(from, dir) {
    var cells = flkty.getCellElements();
    var n = cells.length;
    if (!n) return from;
    for (var step = 1; step <= n; step++) {
      var i = (((from + dir * step) % n) + n) % n;
      if (cellMatches(cells[i])) return i;
    }
    return from;
  }

  /* Ràng buộc điều hướng carousel ảnh lớn: mũi tên/vuốt chỉ đi giữa các ảnh KHỚP màu hiện tại
     (+ 360/video), bỏ qua ảnh màu khác — thay vì xoá cell (an toàn với logic đổi variant của theme). */
  function bindNavConstrainOnce() {
    if (navBound || !flkty) return;
    navBound = true;
    var scope = flkty.element.closest('#product-photos') || document;

    // Mũi tên prev/next: chặn handler mặc định của Flickity, tự chọn ảnh khớp kế tiếp.
    scope.addEventListener('click', function (e) {
      if (!MATERIALS.length) return;
      var btn = e.target.closest('.flickity-prev-next-button');
      if (!btn || !scope.contains(btn)) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      var dir = btn.classList.contains('previous') ? -1 : 1;
      flkty.select(nextMatchingCell(flkty.selectedIndex, dir));
    }, true);

    // Vuốt: nhớ hướng; khi dừng ở ảnh màu khác thì nhảy tiếp tới ảnh khớp gần nhất.
    flkty.on('dragMove', function (event, pointer, moveVector) {
      if (moveVector && Math.abs(moveVector.x) > 2) dragDir = moveVector.x < 0 ? 1 : -1;
    });
    flkty.on('settle', function () {
      if (!MATERIALS.length) return;
      var cells = flkty.getCellElements();
      if (cellMatches(cells[flkty.selectedIndex])) return;
      var target = nextMatchingCell(flkty.selectedIndex, dragDir);
      if (target !== flkty.selectedIndex) flkty.select(target);
    });
  }

  function reload(material) {
    material = material == null ? '' : String(material);
    if (material === last.material) return;
    last.material = material;

    // Lọc thumbnail theo màu ngay (không chờ API) để dải cập nhật tức thì.
    if (ensureFlkty()) filterThumbs(material);

    var token = ++reqId;
    // Cả spin lẫn video đều key theo material (video trả mảng items -> dùng items[0]).
    // Dựng lại cả hai, đúng thứ tự: spin trước video, đặt sau 2 ảnh đầu đang hiện.
    getMedia(material)
      .then(function (res) {
        if (token !== reqId || !ensureFlkty()) return;
        filterThumbs(material);
        removeVideo();
        removeSpin();

        var s = res[0];
        var spinCell = (s && s.base_url && s.frame_count) ? applySpin(s) : null;
        var items = (res[1] && res[1].items) || [];
        var videoCell = items.length ? applyVideos(items) : null;

        // Chèn cell 360/video ngay SAU ảnh chính thứ 2 của màu hiện tại (khớp vị trí thumbnail) để
        // vuốt/bấm mũi tên đi qua đúng thứ tự, không bị bỏ qua. Không đủ 2 ảnh thì chèn cuối.
        var anchor = nthMatchingCellIndex(material, 2);
        var at = anchor >= 0 ? anchor + 1 : flkty.cells.length;
        resetFade();
        if (spinCell) { flkty.insert(spinCell, at); at++; }
        if (videoCell) { flkty.insert(videoCell, at); at++; }

        placeThumbs();
        resyncIndices();
      })
      .catch(function () { /* fail-open: lỗi mạng thì không chèn gì */ });
  }

  function optionValue(variant, index) {
    if (isNaN(index) || index < 0 || !variant) return '';
    if (variant.options && variant.options[index] != null) return variant.options[index];
    return variant['option' + (index + 1)] || '';
  }

  function start() {
    if (!ensureFlkty()) return false;
    bindChangeOnce();
    bindNavConstrainOnce();

    reload(config.getAttribute('data-init-material'));

    // Đổi Material: theme phát 'variantinputchange' kèm nguyên object variant trên bus toàn cục
    // Events (assets/product.js updateVariantInput). Chạy cả chế độ select lẫn swatch.
    if (window.Events && window.Events.on) {
      window.Events.on('variantinputchange', function (variant) {
        if (!variant) return;
        reload(optionValue(variant, matIndex));
      });
    }
    return true;
  }

  function boot() {
    var tries = 0;
    (function attempt() {
      if (start()) return;
      if (++tries > 80) return; // ~12s: Flickity nạp lười, chờ tới khi sẵn sàng rồi thôi
      setTimeout(attempt, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();